/**
 * One-time, per-device flags for the first-run experience, stored in
 * localStorage. Mirrors the pattern in `stores/onboardingStore.ts` and the
 * push hook's `web_push_auto_prompted` key. Reads fail *closed* (treated as
 * "already seen") so a storage error never traps the user in a loop.
 */
const INTRO_KEY = "mash.intro.v1";
const NOTIF_PROMPT_KEY = "mash.notifPrompt.v1";

function read(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return true;
  }
}

function write(key: string): void {
  try {
    window.localStorage.setItem(key, "1");
  } catch {
    /* ignore */
  }
}

/** The pre-login onboarding intro screen. */
export const hasSeenIntro = (): boolean => read(INTRO_KEY);
export const markIntroSeen = (): void => write(INTRO_KEY);

/** The in-app notification-permission modal shown once after onboarding. */
export const hasSeenNotifPrompt = (): boolean => read(NOTIF_PROMPT_KEY);
export const markNotifPromptSeen = (): void => write(NOTIF_PROMPT_KEY);
